export default[
    {
        path:'/principal',
        name:'principal',
        component: () => import(/* webpackChunkName: "principal" */ '@/views/Principal.vue'),
        meta: {
            requiresAuth: true,
            roles:['ROLE_PACIENTES', 'ROLE_ORTOPAC', 'ROLE_MTTO', 'ROLE_LABORATORIO'],
        },

    }
]